import { Text, View } from '@react-pdf/renderer';
import { styles } from './PDFStyles';

const PDFHeader = ({ Aerotech, Aftermarket }) => {
    return (
        Aerotech ? 
            <View fixed style={[styles.flex, styles.footer]}>         
                <Text>            
                    {Aftermarket && <>
                        All quotations are subject to Standard QA Documentation.
                        {"\n"}
                        Minimum Order Value of $250 + GST applies to all quotations.
                        {"\n"}{"\n"}
                    </>} 
                    Subject to Aerotech Standard Terms & Conditions of Sale, available at https://www.aerotechfans.com.au/terms-and-conditions/
                </Text>   
            </View> :
            <View fixed style={[styles.flex, styles.footer]}>           
                <Text>           
                    {Aftermarket && <>
                        All quotations are subject to Standard QA Documentation.
                        {"\n"}
                        Minimum Order Value of $250 + GST applies to all quotations.
                        {"\n"}{"\n"}
                    </>}  
                    Subject to AirEng Standard Terms & Conditions of Sale, available at https://www.aireng.com.au/wp-content/uploads/STANDARD-TERMS-CONDITIONS-25-Sept-2013.pdf
                </Text>     
            </View>
    );
};

export default PDFHeader;
